module.exports = __webpack_public_path__ + "static/Play_Circle_BG-d6b4747a3ef048409475324dbd9ac252.png";